/**
 * @generated SignedSource<<786f1007a6af1730b92980dd25753886>>
 * @relayHash 917128614372b454a0c92f921e265a3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ObjectCommentContainerPreloadObjectCommentsQuery$variables = {
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null | undefined> | null | undefined;
  first?: AGG$Long | null | undefined;
  pageId: string;
};
export type ObjectCommentContainerPreloadObjectCommentsQuery$data = {
  readonly comments: {
    readonly __typename: "PaginatedCommentList";
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly __typename: string;
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly permissionType: SitePermissionType | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
        readonly type: string | null | undefined;
      };
      readonly body: {
        readonly value: string;
      };
      readonly container: {
        readonly id: string | null | undefined;
      };
      readonly contentStatus: string;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null | undefined;
        readonly webui: string | null | undefined;
      };
      readonly location: {
        readonly __typename: string;
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null | undefined;
          readonly resolvedTime: AGG$Long | null | undefined;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly inlineMarkerRef?: string | null | undefined;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null | undefined;
          readonly resolvedTime: AGG$Long | null | undefined;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly inlineText?: string | null | undefined;
        readonly type: string;
      };
      readonly parentId: string | null | undefined;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly reactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null | undefined>;
      } | null | undefined;
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly __typename: string;
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly permissionType: SitePermissionType | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null | undefined;
          readonly webui: string | null | undefined;
        };
        readonly location: {
          readonly __typename: string;
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null | undefined;
            readonly resolvedTime: AGG$Long | null | undefined;
            readonly resolvedUser: string | null | undefined;
          } | null | undefined;
          readonly inlineMarkerRef?: string | null | undefined;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null | undefined;
            readonly resolvedTime: AGG$Long | null | undefined;
            readonly resolvedUser: string | null | undefined;
          } | null | undefined;
          readonly inlineText?: string | null | undefined;
          readonly type: string;
        };
        readonly parentId: string | null | undefined;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly reactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null | undefined>;
        } | null | undefined;
        readonly version: {
          readonly by: {
            readonly __typename: string;
            readonly displayName: string | null | undefined;
          } | null | undefined;
          readonly number: number | null | undefined;
          readonly when: string | null | undefined;
        };
      } | null | undefined>;
      readonly version: {
        readonly by: {
          readonly __typename: string;
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly friendlyWhen: string | null | undefined;
        readonly number: number | null | undefined;
        readonly when: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type ObjectCommentContainerPreloadObjectCommentsQuery = {
  response: ObjectCommentContainerPreloadObjectCommentsQuery$data;
  variables: ObjectCommentContainerPreloadObjectCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v3 = {
  "kind": "Variable",
  "name": "pageId",
  "variableName": "pageId"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v8 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v11 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v12 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v13 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v14 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v11/*: any*/)
},
v15 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v16 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v18 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v19 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v20 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v21 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "commentResolveProperties",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/)
          ]
        }
      ],
      "type": "FooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "inlineMarkerRef"
        },
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "inlineResolveProperties",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isDangling"
            },
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "inlineText"
        }
      ],
      "type": "InlineComment"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v23 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v24 = {
  "args": [
    {
      "kind": "Literal",
      "name": "childType",
      "value": "comment"
    },
    {
      "kind": "Literal",
      "name": "contentType",
      "value": "page"
    },
    (v3/*: any*/)
  ],
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "reactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "number"
},
v26 = {
  "kind": "ScalarField",
  "name": "when"
},
v27 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "confluenceCommentFilter",
        "value": {
          "commentState": "UNRESOLVED",
          "commentType": "FOOTER"
        }
      },
      {
        "kind": "Variable",
        "name": "contentStatus",
        "variableName": "contentStatus"
      },
      {
        "kind": "Literal",
        "name": "depth",
        "value": "ROOT"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      (v3/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": [
          "FOOTER"
        ]
      }
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ]
          },
          (v12/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ]
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "replies",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v8/*: any*/)
                ]
              },
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v25/*: any*/),
                  (v26/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/),
                  (v6/*: any*/),
                  (v10/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "friendlyWhen"
              },
              (v25/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      (v5/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
    "selections": (v27/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
    "selections": (v27/*: any*/)
  },
  "params": {
    "cacheID": "917128614372b454a0c92f921e265a3f",
    "id": "d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb",
    "metadata": {},
    "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
    "operationKind": "query",
    "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
  }
};
})();

(node as any).hash = "0538003061ae5e768497e01082e44e58";

export default node;
